const LocationList = () => import('Views/location/location-list');
const LocationAddEdit = () => import('Views/location/location-addEdit');
const LocationDetail = () => import('Views/location/location-detail');

export default[
  { path: '/location-list', component: LocationList },
  { path: '/location-add', component: LocationAddEdit },
  { path: '/location-edit/:id', component: LocationAddEdit },
  { path: '/location-detail/:id', component: LocationDetail },
];



// WEBPACK FOOTER //
// ./src/router/location.js